import { FormElement, FormProperty, FormValue } from './Form.types'
import { COMPONENT_INTERFACE } from './Form.constants'
import { IOption } from '../../common/common.types'

export const propValue = (props?: FormProperty[], key?: string) => {
  if (!props || !key) return undefined
  return props.find((p) => p.key === key)?.value
}

export const matchesFilter = (element: FormElement, filterKey: string, filterValue: unknown) => {
  const prop = element.properties?.find((p) => p.key === filterKey)
  return prop?.value === filterValue
}

export const toOptions = (opts?: { id?: number; name?: string; [key: string]: unknown }[]) => {
  return (opts ?? []).map((o) => {
    return {
      ...o,
      id: o.id,
      name: o.name,
    }
  })
}

export const defaultFor = (el: FormElement) => {
  switch (el.componentInterface) {
    case COMPONENT_INTERFACE.STRING_INPUT:
      return ''
    case COMPONENT_INTERFACE.MULTI_SELECT:
      return [] as (string | number)[]
    case COMPONENT_INTERFACE.SINGLE_SELECT:
      return null as string | number | null
    case COMPONENT_INTERFACE.CREW_INPUT:
      return null as string | number | null
    case COMPONENT_INTERFACE.TOGGLE:
      return false
    case COMPONENT_INTERFACE.DATE_TIME:
      return null
    case COMPONENT_INTERFACE.NUMBER_PAD:
      return [] as string[]
    default:
      return ''
  }
}

const updateFormField = (
  elementId: string,
  currentFormValue: FormValue,
  newFieldValue: string | number | (string | number)[] | string[] | boolean | null | object | object[],
  onChange: (v: FormValue) => void
) => {
  const updatedFormValue = {
    ...currentFormValue,
    [elementId]: newFieldValue,
  }
  onChange(updatedFormValue)
}

// No-op action that can be safely dispatched by components
const NO_OP_ACTION = { type: '@@FORM/NO_OP' }

export const handleMultiSelectChange = (
  selectedItems: IOption[],
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  updateFormField(elementId, currentFormValue, selectedItems, onChange)
  return NO_OP_ACTION
}

export const handleSingleSelectChange = (
  selectedOption: IOption | null,
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  const valueToSave = selectedOption ? selectedOption : null
  updateFormField(elementId, currentFormValue, valueToSave, onChange)
}

export const handleStringInputChange = (
  event: CustomEvent,
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  const inputValue = event?.detail?.value ?? ''
  updateFormField(elementId, currentFormValue, inputValue, onChange)
}

export const handleToggleChange = (
  isChecked: boolean,
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  updateFormField(elementId, currentFormValue, isChecked, onChange)
  return NO_OP_ACTION
}

export const handleDateTimePickerChange = (
  selectedDate: string | null,
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  updateFormField(elementId, currentFormValue, selectedDate, onChange)
}

export const handleNumberPadChange = (
  numberValues: string[],
  elementId: string,
  currentFormValue: FormValue,
  onChange: (v: FormValue) => void
) => {
  const numberValue = numberValues?.join('')
  updateFormField(elementId, currentFormValue, numberValue, onChange)
}
